/**
 * Created by uiuifree on 2017/04/06.
 */
import axios from 'axios'

const instance = axios.create({
//     timeout: 1000
})

const apiDomain = process.env.COMPANY_API_ROOT

export default {
  corporate: {
    list (params) {
      return instance.get(`${apiDomain}corporates`, {
        params
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/service/CorporateApi.js